<template>
	<div class="exception-body  error">
		<div class="exception-panel">
			<div class="exception-content">
				<img src="assets/layout/images/pages/icon-error.svg" alt="roma"/>
				<h1>Error Occured</h1>
				<p>Something went wrong.</p>
				<Button label="Go To Dashboard" icon="pi pi-arrow-left" @click="goDashboard" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted(){
			this.$clearAllData();
		},
		methods: {
			goDashboard(){
				//console.log("Dashboard cannot load!");
				//this.$router.push({ path: '/info' });
				document.location="/"
			}
		}
	}
</script>

<style scoped>

</style>
